// extracted by mini-css-extract-plugin
export var aircallIframe = "_k1-3";
export var fabContainer = "_k1-5";
export var fabRinging = "_k1-6";
export var loadingOverlay = "_k1-4";
export var pulse = "_k1-7";
export var widgetContent = "_k1-2";
export var widgetPanel = "_k1-0";
export var widgetPanelExpanded = "_k1-1";